export const REQUEST_DEVICE_LOG_OPEN_MODAL = "REQUEST_DEVICE_LOG_OPEN_MODAL";
export const REQUEST_DEVICE_LOG_CLOSE_MODAL = "REQUEST_DEVICE_LOG_CLOSE_MODAL";

export const REQUEST_DEVICE_LOG_REQUEST = "REQUEST_DEVICE_LOG_REQUEST";
export const REQUEST_DEVICE_LOG_RESULT = "REQUEST_DEVICE_LOG_RESULT";